<template>
    <div>

        <div class="col-xs-12 col-sm-6 col-md-4 agx-list-oneInRow" v-bind:style="{'background':'url('+item.thumbPath+')','height':'250px','background-size': '100% auto'}">

            <div>
                <div>
                    <div class="agx-post-tag" style="z-index:1;">
                        <div class="label label-primary" style="z-index:1;display:inline-block;">{{item.parentCategory.name}} </div> /
                        <div class="label label-info" style="z-index:1;display:inline-block;"> {{item.category.name}} </div>
                    </div>
                    <div class="agx-post-intros">
                        <div>
                            <router-link :to="{name:'detail',query:{postId:item.postId,scode:item.shopCode}}">
                                {{item.title}}
                            </router-link>
                        </div>
                        <div>

                            <div v-if="cpdPrice!==''">

                                <span style="line-height:34px;padding:4px;">
                                    <span class="agx-money-sign">
                                        {{currency}} {{cpdPrice}}
                                    </span>
                                </span>
                                
                                <span class="btn btn-default" @click="showDetail=true" style="float:right;">+<span class="glyphicon glyphicon-shopping-cart"></span> </span>
                            </div>

                        </div>
                    </div>
                    <div class="agx-trans-layer"></div>
                    <div class="col-xs-4 col-md-4">
                        <router-link :to="{name:'detail',query:{postId:item.postId,scode:item.shopCode}}" v-if="item.thumbPath!==null">
                            <img style="display:inline-block;height:200px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;"
                                 class="agx-post-thumb" :src="item.thumbPath" :title="item.title">
                        </router-link>
                    </div>

                </div>
            </div>
        </div>

        <modal-x :show="showDetail" @onclose="showDetail=false" :contentStyle="{'max-width': '600px', height: '80%'}">
            <add-to-cart :post-id="item.postId" v-if="showDetail" @ondone="showDetail=false" :title="item.title" ></add-to-cart>
        </modal-x>

    </div>
</template>
<script>
    import modalX from '../base/ModalX1.vue';
    import addToCart from '../AddToCart.vue';

    export default {
        components: {
            modalX: modalX,
            addToCart: addToCart
        },
        props: ["item", "itemType"],
        data: function () {
            return {
                showDetail: false
            }
        },
        methods: {

        },
        computed: {
            currency: function () {
                return this.$store.getters.configs.currency;
            },
            cpdPrice: function () {
                var priceArr = this.item.prices;
                if (typeof (priceArr) !== "undefined" && priceArr !== null && priceArr.length > 0) {
                    var priceLow = null;
                    var priceUp = null;
                    var priceText = "";
                    var priceCount = priceArr.length;
                    if (priceCount > 0) {
                        priceLow = priceArr[0];
                    }

                    if (priceCount - 1 > 0) {
                        priceUp = priceArr[priceCount - 1];
                    }

                    if (priceLow !== null) {
                        priceText = priceLow.price;
                    }

                    if (priceUp !== null) {
                        priceText += " -- ";
                        priceText += priceUp.price;
                    }
                    return priceText;
                }
                return "";
            }
        },
        mounted: function () {

        }
    }
</script>